// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__DZxyS","loaderOuter":"PageOverlayLoader_loaderOuter__193CA"};